<div class="container my-5">
  <div class="card shadow">
    <div class="card-body p-5">

      <h1 class="text-center mb-4">
        Terms of Service
      </h1>

      <p><strong>Last Updated:</strong> 2026-02-21</p>

      <hr />

      <h4>1. Introduction</h4>
      <p>
        Welcome to <strong>s1az.com</strong>. These Terms of Service ("Terms")
        govern your use of our website, services, and WhatsApp messaging
        communication powered by the <strong>WhatsApp Business API</strong>.
      </p>
      <p>
        By accessing or using our services, you agree to be bound by these Terms.
        If you do not agree, please do not use our services.
      </p>

      <h4 class="mt-4">2. Services Provided</h4>
      <p>
        s1az.com provides digital services including communication,
        customer support, notifications, invoices, and service updates
        through WhatsApp and other digital platforms.
      </p>

      <h4 class="mt-4">3. User Responsibilities</h4>
      <p>By using our services, you agree to:</p>
      <ul>
        <li>Provide accurate and complete information</li>
        <li>Use our services only for lawful purposes</li>
        <li>Not misuse, disrupt, or attempt to hack our systems</li>
        <li>Not send harmful, illegal, or abusive content</li>
      </ul>

      <h4 class="mt-4">4. WhatsApp Communication</h4>
      <p>
        Our WhatsApp communication services are powered by the WhatsApp Business API
        provided by Meta Platforms, Inc.
      </p>
      <p>
        By communicating with us via WhatsApp, you consent to receive
        transactional messages such as invoices, service updates, and notifications.
      </p>

      <h4 class="mt-4">5. Intellectual Property</h4>
      <p>
        All content, branding, logos, and materials on s1az.com are the
        intellectual property of s1az.com unless otherwise stated.
        Unauthorized use, reproduction, or distribution is prohibited.
      </p>

      <h4 class="mt-4">6. Limitation of Liability</h4>
      <p>
        s1az.com shall not be liable for any indirect, incidental, or
        consequential damages arising from the use or inability to use
        our services.
      </p>
      <p>
        We do not guarantee uninterrupted or error-free service at all times.
      </p>

      <h4 class="mt-4">7. Service Availability</h4>
      <p>
        We reserve the right to modify, suspend, or discontinue
        any part of our services at any time without prior notice.
      </p>

      <h4 class="mt-4">8. Termination</h4>
      <p>
        We may suspend or terminate access to our services if
        you violate these Terms or engage in unlawful activities.
      </p>

      <h4 class="mt-4">9. Privacy</h4>
      <p>
        Your use of our services is also governed by our Privacy Policy.
        Please review it to understand how we collect and process data.
      </p>

      <h4 class="mt-4">10. Governing Law</h4>
      <p>
        These Terms shall be governed and interpreted in accordance with
        the laws of Bangladesh.
      </p>

      <h4 class="mt-4">11. Changes to Terms</h4>
      <p>
        We may update these Terms from time to time.
        Updated versions will be posted on this page with a revised date.
      </p>

      <h4 class="mt-4">12. Contact Information</h4>
      <p>If you have any questions regarding these Terms, please contact:</p>

      <p>
        <strong>s1az.com</strong><br />
        Address: 227, East Rampura, Dhaka, 1219, Bangladesh<br />
        Email: <a href="mailto:info@s1az.com">info&#64;s1az.com</a><br />
        Phone: <a href="tel:+8801706088146">+8801706088146</a>
      </p>

    </div>
  </div>
</div>
